










import { Component, Vue } from 'vue-property-decorator';
import { FilterAction } from '@/store/actions';
import { FilterGetter } from '@/store/getters';

@Component({
  name: 'filter-button-component',
})
export default class FilterButtonComponent extends Vue {
  private get isFilterButtonVisible(): boolean {
    return this.$store.getters[FilterGetter.DisplayFilters]
      && this.$store.getters[FilterGetter.Filters].size > 0;
  }

  private openSideBar() {
    this.$store.dispatch(FilterAction.SetSideBarVisibility, { isOpen: true });
  }
}
